import { createReducer } from "@reduxjs/toolkit";
import { retrieveUserInvitations } from "./retrieve-user-invitations";
import type { RetrievalState } from "@redux/state/shared-types";
import type { UserInvitationVM } from "@shared-kernel/application/ports/admin/admin-repository";

const initialState: RetrievalState<UserInvitationVM[]> = { data: [], fetching: "idle" };

export const retrieveUserInvitationsReducer = createReducer<RetrievalState<UserInvitationVM[]>>(initialState, builder => {
  builder.addCase(retrieveUserInvitations.fulfilled, (state, { payload }) => {
    return {
      ...state,
      data: payload,
      fetching: "success",
    };
  });
  builder.addCase(retrieveUserInvitations.pending, state => {
    return {
      ...state,
      fetching: "pending",
    };
  });
  builder.addCase(retrieveUserInvitations.rejected, state => {
    return {
      ...state,
      fetching: "failed",
    };
  });
});
